function handleTabClick(clickedTab) {
  // Remove 'active' class from all tabs
  document.querySelectorAll('.mobile-facets__tab').forEach(btn => btn.classList.remove('active'));
  // Add 'active' class to the clicked tab
  clickedTab.classList.add('active');
  // Toggle the content visibility based on the clicked tab
  const tabContentType = clickedTab.dataset.tab;  // 'filters' or 'sort'
  document.querySelectorAll('.mobile-facets__tab-content').forEach(content => {
    content.style.display = content.dataset.tabContent === tabContentType ? 'block' : 'none';
  });
}
